export const categories = [
  { id: 'all', name: '全部', icon: 'ri-apps-line', description: '浏览所有分类内容' },
  { id: 'qiyewangzhan', name: '企业官网', icon: 'ri-building-4-line', description: '为企业打造专业品牌形象' },
  { id: 'gerenblog', name: '个人博客', icon: 'ri-article-line', description: '记录生活，分享知识' },
  { id: 'dianshang', name: '电商建站', icon: 'ri-shopping-bag-3-line', description: '快速搭建在线商城' },
  { id: 'jiaoyu', name: '教育培训', icon: 'ri-book-open-line', description: '在线教育网站搭建方案' },
  { id: 'canYin', name: '餐饮美食', icon: 'ri-restaurant-line', description: '餐厅外卖网站制作' },
  { id: 'shejishi', name: '设计师作品集', icon: 'ri-palette-line', description: '展示创意作品的专业网站' },
  { id: 'jianzhanjiaocheng', name: '建站教程', icon: 'ri-guide-line', description: '从零开始学建站' },
];